// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_kuV","cls2":"ReferenceReportPage-cls2_Avn ReferenceReportPage-cls1_kuV"};